<template>
  <b-checkbox
    v-model="localValue"
    class="custom-checkbox-color my-checkbox"
    name="check-button"
    @change="updateValue($event)"
  >
    <span :style="styleTransfer">Giao</span> / <span :style="styleReceive">Nhận</span>
  </b-checkbox>
</template>

<script>
export default {
  name: 'TrasnferReceive',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.localValue = this.value
  },
  computed: {
    styleTransfer: function () {
      if (!this.value) {
        return {
          color: 'green',
          fontWeight: 'bold'
        }
      }
      return {}
    },
    styleReceive: function () {
      if (this.value) {
        return {
          color: 'red',
          fontWeight: 'bold'
        }
      }
      return {}
    }
  },
  data () {
    return {
      localValue: ''
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event)
    }
  }
}
</script>

<style scoped>
  .my-checkbox, .my-checkbox span{
    user-select: none;
  }
</style>
